import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const Referrals = () => {
  const data = [
    { id: "Ref-001", name: "Antony Lewis", role: "IOS Dev", bonus: "$200" },
    { id: "Ref-002", name: "Brian", role: "PHP Dev", bonus: "$100" },
  ];

  return (
    <div className="container mt-4">
      <style>{`
        .card-row { box-shadow:0 4px 12px rgba(0,0,0,0.08); border-radius:10px; }
      `}</style>

      <h4>Referrals</h4>

      {data.map((item, i) => (
        <div key={i} className="card p-3 mb-3 card-row">
          <div className="row align-items-center">
            <div className="col-md-2">{item.id}</div>
            <div className="col-md-3">{item.name}</div>
            <div className="col-md-3">{item.role}</div>
            <div className="col-md-2">{item.bonus}</div>
            <div className="col-md-2 text-end">
              ✏️ 🗑
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Referrals;